import { nullUndefined } from '@acri-tools/react-tools/utils/global';
import classNames from 'classnames';
import React,{ Component } from 'react';

import './InputPeriodList.css';

interface Props{
    label: string|React.ReactNode
    values: Array<any>
    onChange: (values:Array<any>) => void
    placeholder?: string
    datetime?:boolean
}
interface State{
    value: {
        start: string
        stop: string
    }
}


export default class InputPeriodList extends Component<Props,State>{
    constructor(props:Props){
        super(props);
        this.state={
            value: {
                start: '',
                stop: ''
            }
        }
    }

    render(){
        return (
            <div className="input-period-list">
                
                <div className="input-period-list-add">
                    <div className="form-field">
                        <label>{this.props.label}</label>
                        { this.get_input(this.state.value) }
                    </div>
                    <div 
                        className={classNames({
                            "input-period-list-operation add": true,
                            "disabled": !this.values_filled()
                        })}
                        onClick={this.add_value}
                    >
                        <i className="fas fa-plus"/> ADD
                    </div>
                </div>
                {
                    this.props.values.length > 0 &&
                    <div className="input-period-list-values">
                        {
                            this.props.values.map((value:any, index: number)=>(
                                <div className="input-period-list-value">
                                    <div className="form-field">
                                        { this.get_input(value) }
                                    </div>
                                    <div 
                                        className="input-period-list-operation delete"
                                        onClick={()=>{ this.remove_value(index) }}
                                    >
                                        <i className="fas fa-times"/> REMOVE
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                }
            </div>
        );
    }

    values_filled = () =>{
        return this.state.value.start !== '' && this.state.value.stop !== '';
    }

    keypress_handler = (e:any) =>{
        if(e?.keyCode === 13){
            this.add_value()
        }
    }

    add_value = () =>{
        if(this.values_filled()){
            let { values } = this.props;
            values.push({ ...this.state.value});
            this.props.onChange(values);
            this.setState({ value: { start:'', stop:'' } });
        }
    }
    remove_value = (index:number) =>{
        let { values } = this.props;
        values.splice(index, 1);
        this.props.onChange(values);
        this.forceUpdate();
    }

    get_input = (value: { start:string, stop:string }, main?:boolean) =>{
        return ( 
        <div className="input-period-inputs">
            <input 
                placeholder={`Start`}
                type={this.props.datetime ? "datetime-local" : "date"} value={value.start}
                onChange={(e)=>{
                    value.start = e.target.value;
                    this.forceUpdate();
                }}
                onKeyDown={main ? undefined : this.keypress_handler}
            /> 
            <input 
                placeholder={`Stop`}
                type={this.props.datetime ? "datetime-local" : "date"} value={value.stop}
                onChange={(e)=>{
                    value.stop = e.target.value;
                    this.forceUpdate();
                }}
                onKeyDown={main ? undefined : this.keypress_handler}
            /> 
            {/* <CalendarPicker value={value}/> */}
        </div>)
    }

};